"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsonGetDefaultPathsForPrintTemplate = exports.getDefaultPathsForPrintTemplate = exports.parseDataPaths = exports.getAllPermutationsOfPath = exports.removeIx = void 0;
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var flat_1 = __importDefault(require("flat"));
var util_1 = require("./util");
var set_1 = __importDefault(require("lodash/set"));
var merge_1 = __importDefault(require("lodash/merge"));
var util_2 = require("../../view-config/util");
var Option_1 = require("fp-ts/lib/Option");
var Either_1 = require("fp-ts/lib/Either");
var extractDataPathsFromDocumentB64_1 = __importDefault(require("./extractDataPathsFromDocumentB64"));
var jszip_1 = __importDefault(require("jszip"));
var docxtemplater_1 = __importDefault(require("docxtemplater"));
var getSelectionExpression_1 = require("../../spel/getFieldsInAst/getSelectionExpression");
var isPlaceHolderTag = function (tag) {
    return tag.type === 'placeholder';
};
var isLoopTag = function (tag) {
    return tag.module === 'loop';
};
/*
    Returns an object structure of placeholder values
    e.g.
    {
        address: {
            client: {
                firstName: {},
                lastName: {}
            }
        }
    }
*/
var getExpansionFromFilterArgument = function (matched) {
    var quoteStrings = [
        { start: "'", end: "'" },
        { start: '"', end: '"' },
        { start: "\u2019", end: '’' },
        { start: '`', end: '`' },
        { start: '“', end: '”' },
    ];
    var stringIsQuoted = quoteStrings.find(function (_a) {
        var start = _a.start, end = _a.end;
        return matched.startsWith(start) && matched.endsWith(end);
    });
    var path = stringIsQuoted ? matched.slice(1, -1) : matched;
    if (path.indexOf('.') !== -1) {
        // now we care about the expansion here
        return path.slice(path[0] === '-' ? 1 : 0, path.lastIndexOf('.'));
    }
    return null;
};
var getTags = function (postParsed) {
    return postParsed
        .filter(function (tag) { return isPlaceHolderTag(tag) || isLoopTag(tag); })
        .reduce(function (prev, curr) {
        var _a, _b;
        /*
        Set the object path for all fields parsed in an expression (parsed as SPEl,
                so only pass valid spel expressions even though we are using angular parser)
    */
        var setFieldsInExpression = function (expressionToParse) {
            if (expressionToParse === '.') {
                return;
            }
            var fieldsUsedInExpression = (0, util_1.getFieldsInExpression)()(expressionToParse);
            fieldsUsedInExpression.forEach(function (fieldExpression) {
                prev = (0, merge_1.default)({}, prev, (0, set_1.default)({}, fieldExpression, {}));
            });
        };
        if (isPlaceHolderTag(curr) && curr.value && curr.value.startsWith('$') && curr.value.endsWith('$')) {
            // this is a spel tag. <[firstName]>
            var parse1_1 = (0, getSelectionExpression_1.getNextBracketedExpression)({
                bracketClosesOn: '>>',
                bracketNaivelyOpensOn: '<<',
                bracketOpensOn: '<<',
            });
            var parse2_1 = (0, getSelectionExpression_1.getNextBracketedExpression)({
                bracketClosesOn: ']>',
                bracketNaivelyOpensOn: '<[',
                bracketOpensOn: '<[',
            });
            var accumulateExpressions = function (template) {
                var expressions = [];
                var evalString = function (str, parser) {
                    parser(str).fold(str, function (_a) {
                        var inner = _a.inner, after = _a.after;
                        expressions.push(inner);
                        evalString(after, parser);
                        return '';
                    });
                };
                evalString(template, parse1_1);
                evalString(template, parse2_1);
                return expressions;
            };
            var dataTemplatedIntoSpel = accumulateExpressions(curr.value.slice(1, -1));
            dataTemplatedIntoSpel.forEach(function (field) { return setFieldsInExpression(field); });
            return prev;
        }
        var singleVariableRGX = /^[\s]*[_\-a-zA-Z]+[_\-a-zA-Z0-9]*[\s]*$/;
        // expression match group indexes are
        // 1 (before filter applied)
        // (optional) 3
        // const filterExpressionRGX = /^(.*)\s+\|\s+[a-zA-Z]+\s*(:\s*([^\s]+))?$/; // https://regex101.com/r/Mq6RRO/1
        // filters like joinBy contain whitespace as arguments (like ', ')
        // const filterExpressionRGX = /^(.*)\s+\|\s+[a-zA-Z]+\s*(:\s*(.+))?$/;
        // fixed to allow chaining filters
        var filterExpressionRGX = /^\s*([a-zA-Z0-9_-]*)\s+(\|\s+[a-zA-Z]+\s*(:\s*(.+))*)*$/;
        var expression = isPlaceHolderTag(curr) && ((_a = curr.value) === null || _a === void 0 ? void 0 : _a.startsWith('%'))
            ? curr.value.slice(1)
            : isLoopTag(curr)
                ? (_b = curr.raw) === null || _b === void 0 ? void 0 : _b.slice(1) // slice off #
                : curr.value;
        if (expression.match(singleVariableRGX)) {
            // this is now a scope
            if ((0, isEmpty_1.default)(prev[expression])) {
                prev[expression] = {};
            }
            if (curr.subparsed) {
                prev[expression] = (0, merge_1.default)({}, prev[expression], getTags(curr.subparsed));
            }
        }
        else {
            var filterExpressionMatch_1 = filterExpressionRGX.exec(expression);
            if (filterExpressionMatch_1) {
                var expressionBeforeFilter_1 = filterExpressionMatch_1[1];
                if (expressionBeforeFilter_1) {
                    setFieldsInExpression(expressionBeforeFilter_1);
                    // {numberField | toFixed: 2} has no subparsed (causing getTags to throw error),
                    // so adding the check for it below
                    if (expressionBeforeFilter_1.match(singleVariableRGX) && curr.subparsed) {
                        prev[expressionBeforeFilter_1] = (0, merge_1.default)({}, prev[expressionBeforeFilter_1], getTags(curr.subparsed));
                    }
                    /**
                 * Example matches:
                 *
                 *
                 *  "previousAddresses | orderBy : 'address.state.code'",
                    'previousAddresses',
                    "| orderBy : 'address.state.code'",
                    ": 'address.state.code'",
                    "'address.state.code'",  <----------------Index 4
                    index: 0,
                    input: "previousAddresses | orderBy : 'address.state.code'",
                    groups: undefined

                    "strs | joinBy: '; '",
                    'strs',
                    "| joinBy: '; '",
                    ": '; '",
                    "'; '", <-------------------- Index 4
                    index: 0,
                    input: "strs | joinBy: '; '",
                    groups: undefined

                    "concerns | withIndexes | orderByNullsLast: 'startDate':'timeFrame':'outcome'",
                    'concerns',
                    "| orderByNullsLast: 'startDate':'timeFrame':'outcome'",
                    ": 'startDate':'timeFrame':'outcome'",
                    "'startDate':'timeFrame':'outcome'", <----------------------------Index 4
                    index: 0,
                    input: "concerns | withIndexes | orderByNullsLast: 'startDate':'timeFrame':'outcome'",
                    groups: undefined
                 */
                    (function () {
                        // deal with expansions in filter arguments.
                        var filterArgs = filterExpressionMatch_1[4];
                        if (!filterArgs) {
                            return;
                        }
                        filterArgs
                            .split(':')
                            .map(function (arg) { return arg.trim(); })
                            .forEach(function (arg) {
                            var expansion = getExpansionFromFilterArgument(arg);
                            if (expansion) {
                                (0, set_1.default)(prev, "".concat(expressionBeforeFilter_1, ".").concat(expansion), {});
                            }
                        });
                    })();
                }
            }
            else {
                if (expression) {
                    setFieldsInExpression(expression);
                }
                if (curr.subparsed) {
                    prev = (0, merge_1.default)({}, prev, getTags(curr.subparsed));
                }
            }
        }
        return prev;
    }, {});
};
var removeIx = function (path, i) {
    return __spreadArray(__spreadArray([], path.slice(0, i), true), path.slice(i + 1), true);
};
exports.removeIx = removeIx;
var getAllPermutationsOfPath = function (path) {
    var subPaths = path.split('.');
    if (subPaths.length === 1) {
        return subPaths;
    }
    var res = [subPaths[subPaths.length - 1]];
    var _loop_1 = function (i) {
        res = res.concat(res.map(function (p) { return "".concat(subPaths[i], ".").concat(p); }));
    };
    for (var i = subPaths.length - 2; i >= 0; i--) {
        _loop_1(i);
    }
    return res;
};
exports.getAllPermutationsOfPath = getAllPermutationsOfPath;
/*
    takes document tags, and returns a list of all the possible valid expansions for each expansion
*/
var parseDataPaths = function (tags, viewConfig, rootEntity) {
    // Useful for debugging
    /*
    const getPlaceHolderTags = tags =>
        tags
            .filter(isPlaceHolderTag)
            .map((t: PlaceholderTag) => ({ ...t, subparsed: t.subparsed && getPlaceHolderTags(t.subparsed) }));
    */
    // console.log('placeholdertags', JSON.stringify(getPlaceHolderTags(tags), null, 4));
    var tagStructure = getTags(tags);
    // console.log(JSON.stringify(tagStructure, null, 4));
    /*
        deepestTagPaths: [
            address.client.firstName
            address.client.lastName
        ]
    */
    var deepestTagPaths = Object.keys((0, flat_1.default)(tagStructure));
    /*
        To find all possible combinations, for each individual tag path,
        try any in-order permutation of the path, where you only can remove items.
        So, for the above example,
        
        firstName,
        address.firstName,
        address.client.firstName,
        client.firstName
        
        see
    */
    var possiblePaths = deepestTagPaths.map(exports.getAllPermutationsOfPath);
    var res = possiblePaths.map(function (pp) {
        return pp.filter(function (p) {
            // filter if it's a valid traversal
            var res = (0, util_2.isValidEntityFieldExpression)(viewConfig.entities, rootEntity, p);
            return res;
        });
    });
    return res;
};
exports.parseDataPaths = parseDataPaths;
/*
    Default, meaning, always pick the deepest of all possible paths.
*/
var getDefaultPathsForPrintTemplate = function (viewConfig, entityConfName, docB64) {
    return (0, Option_1.fromEither)((0, Either_1.tryCatch)(function () {
        return (0, extractDataPathsFromDocumentB64_1.default)({
            JSZIP: jszip_1.default,
            DocxTemplater: docxtemplater_1.default,
            viewConfig: viewConfig,
        })(entityConfName, docB64);
    })
        .map(function (paths) {
        return paths
            .map(function (possiblePaths) {
            return possiblePaths.reduce(function (prev, curr) {
                if (curr.length > prev.length) {
                    return curr;
                }
                return prev;
            }, '');
        })
            .filter(function (p) { return p; });
    })
        .mapLeft(function (e) {
        console.error('failed to find valid default paths for the document. Error below:');
        console.error(e);
        return e;
    }));
};
exports.getDefaultPathsForPrintTemplate = getDefaultPathsForPrintTemplate;
/*
    THIS IMPLEMENTATION FAILS SILENTLY (.getOrElse([]))
*/
var jsonGetDefaultPathsForPrintTemplate = function (viewConfig, entityConfName, docB64) {
    return (0, exports.getDefaultPathsForPrintTemplate)(JSON.parse(viewConfig), entityConfName, docB64).getOrElse([]);
};
exports.jsonGetDefaultPathsForPrintTemplate = jsonGetDefaultPathsForPrintTemplate;
//# sourceMappingURL=index.js.map